import React from 'react';
import './CustomDropdown.css';

class CustomDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedLabel: this.getSelectedLabel()
    };
    this.dropdownRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selectedLabel: this.getSelectedLabel() });
    }
  }

  handleClickOutside(event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  }

  getSelectedLabel() {
    const selectedOption = this.props.options.find(opt => opt.value === this.props.value);
    return selectedOption ? selectedOption.label : '';
  }

  toggleDropdown = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  selectOption = (value, label) => {
    this.setState({ 
      isOpen: false,
      selectedLabel: label
    });
    // Create a synthetic event that matches the select onChange event
    const syntheticEvent = {
      target: { value: value.toString() },
      currentTarget: { value: value.toString() },
      preventDefault: () => {},
      stopPropagation: () => {}
    };
    this.props.onChange(syntheticEvent);
  };

  render() {
    const { options, className = '' } = this.props;
    const { isOpen, selectedLabel } = this.state;

    return (
      <div className={`custom-dropdown ${className} ${isOpen ? 'open' : ''}`} ref={this.dropdownRef}>
        <div className="dropdown-header" onClick={this.toggleDropdown}>
          <span className="dropdown-value">{selectedLabel}</span>
          <svg 
            className="dropdown-arrow" 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        
        {isOpen && (
          <div className="dropdown-list">
            <div className="dropdown-list-inner">
              {options.map((option) => (
                <div
                  key={option.value}
                  className={`dropdown-option ${option.value === this.props.value ? 'selected' : ''}`}
                  onClick={() => this.selectOption(option.value, option.label)}
                >
                  {option.label}
                  {option.value === this.props.value && (
                    <svg 
                      className="check-icon" 
                      width="16" 
                      height="16" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="3" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CustomDropdown;